import React from 'react';
import "../../pages/DashBoard.css"

const ProViewField = ({labelText, value, width='200px'}) => {
    return (
        <div className="p-field p-grid view-form">
            <label className="p-col-fixed" style={{ width: width, fontWeight: 'bold' }}>{labelText}:</label>
            <div className="p-col">
                {value}
            </div>
        </div>

    )
}

export default ProViewField;